import { component } from "picoapp";
import { type Job, fetchJobs, partitionJobs } from "../../utilities/greenhouse";

export const jobsBoard = component(async (node) => {
  const BOARD_TOKEN = node.dataset.boardToken;
  const { jobs } = await fetchJobs(BOARD_TOKEN);
  const categorizedJobs = partitionJobs(jobs);
  const jobCategories = Object.keys(categorizedJobs).sort();

  const jobsHTMLText = jobCategories.reduce((htmlText, category) => {
    return `
      ${htmlText}
      <div class="tw-mb-10">
        <h4 class='tw-text-black md:tw-text-3xl tw-text-2xl tw-mb-6 tw-font-bold'>${category}</h4>
        <ul aria-label='jobs for ${category}'>
          ${categorizedJobs[category].reduce((_htmlText, job: Job) => {
            return `
                ${_htmlText}
                <li class='md:tw-mb-5 tw-mb-4'>
                  <a class="tw-text-hunter-green tw-font-bold md:tw-text-2xl tw-text-xl" href="${job.absolute_url}">${job.title}</a>
                  <p class="tw-text-gray-500 md:tw-text-xl tw-text-lg">${job.location.name}</p>
                </li>
              `;
          }, "")}
        </ul>
      </div>
    `;
  }, "");

  node.innerHTML = jobsHTMLText;
});
